<template>
  <div
    class="t-grid-cell"
    :data-cell-size="size"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 't-grid-cell',

  props: {
    size: Number,
  },
};
</script>
